import cookie from 'js-cookie';
import radio from 'radio';
import reqwest from 'reqwest';

import Controllerator from './lib/Controllerator.js';

import * as controllers from './controllers.js';
import * as services from './services.js';

import trackingControllers from './controllers/clickTrackers.js';
import { addHeaderRequestInterceptor } from './services/jsonfetchservice.js';
import {
    getToken,
    requestShouldIncludeToken,
} from './services/csrfTokenService.js';

// TODO: remove when this is in the polyfill package
if (!document.baseURI) {
    Object.defineProperty(document, 'baseURI', {
        get() {
            const base = document.querySelector('base');
            return base ? base.href : window.location.href;
        },
    });
}

main();

function main() {
    // This is the main controller
    const c = new Controllerator();

    // Because of ad-blockers, this object might not exist.
    if (!window.FINN) {
        window.FINN = {};
    }

    const globals = ['window', 'document', 'DetailsPolyfill', 'FINN'];

    globals.forEach(global => {
        if (window[global]) {
            c.registerInstance(global, window[global]);
        }
    });

    c.registerInstance('cookie', cookie);
    c.registerInstance('radio', radio);
    c.registerInstance('reqwest', reqwest);

    Object.assign(controllers, trackingControllers);

    Object.keys(services).forEach(name => c.registerService(services[name]));

    Object.keys(controllers).forEach(name =>
        c.registerController(name, controllers[name])
    );

    addCsrfInterceptor();
    // Kick off ALL the things. Meaning evaluating all data-controller attrs on page
    c.run();

    // Remove old stuff
    try {
        c.injector.get('bucketcookieservice').delete('showVideo');
        c.injector.get('bucketcookieservice').delete('bapSurvey');
        c.injector.get('bucketcookieservice').delete('bapSizeAndBrandSurvey');
        c.injector.get('bucketcookieservice').delete('betaInfoWasClosed');
        c.injector.get('bucketcookieservice').delete('betaInfoDate');
        c.injector.get('bucketcookieservice').delete('artAndAntiqueSurvey');
        c.injector.get('bucketcookieservice').delete('sportAndOutdoorsSurvey');
        c.injector
            .get('bucketcookieservice')
            .delete('bapParentAndChildrenSurvey');
        c.injector
            .get('bucketcookieservice')
            .delete('bapFurnitureAndInteriorSurvey');
        c.injector
            .get('bucketcookieservice')
            .delete('bapCarBoatMCEquipmentSurvey');
        c.injector.get('bucketcookieservice').delete('topFilterInfoClosed');
        c.injector.get('bucketcookieservice').delete('topFilterOptOut');
        c.injector.get('objectstore').del('recent_searches');
    } catch (err) {
        // Do nothing
    }

    runSW();
}

function runSW() {
    if (navigator.serviceWorker) {
        navigator.serviceWorker.register('/sw.js').catch(() => {});
    }
}

function addCsrfInterceptor() {
    const csrfToken = getToken();

    addHeaderRequestInterceptor(({ method = 'GET' }) => {
        if (csrfToken && requestShouldIncludeToken(method)) {
            return {
                'x-csrf-token': csrfToken,
            };
        }

        return {};
    });
}



// WEBPACK FOOTER //
// ./main.js